import QuestionInputModal from './QuestionInputModal';

export default QuestionInputModal;
